import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// RequestOptions
import { Config } from '../../config';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  constructor(private httpClient: HttpClient, private Config: Config) { }

  getUsersFromProject(project: any) {
    let params = new HttpParams();
    params = params.append('applicationID', project.applicationId);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getUsersByApplication`,
        { headers: header, params: params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getUsersFromApplicationByID(project: any) {
    let params = new HttpParams();
    params = params.append('applicationID', project);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getUsersByApplication`,
        { headers: header, params: params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getUsersFromOrgPrj(project: any) {
    let params = new HttpParams();
    params = params.append('projectID', project._id);
    params = params.append('orgID', project.orgId);

    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getUsersByOrgAndProject`,
        { headers: header, params: params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getUsersFromOrg() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getUsersByOrg`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  checkUserExistsinSystem(invite: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = invite;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/checkUserExistsinSystem`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  inviteUser(invite: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = invite;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addUserToOrg`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  removeUserFromOrg(userList: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = userList;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/removeUserFromOrg`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  orgAdminChange(userList: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = userList;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/changeOrgAdmin`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addUsersToProject(userList: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = userList;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addUsersToProject`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getUsersFromProjectOrgID(currProject: any) {
    let params = new HttpParams();
    params = params.append('orgID', currProject.orgId);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getUsersByOrgProjectID`,
        { headers: header, params: params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updateUsersFromApplication(userData: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = userData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/updateUsersByApplication`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  changePassword(newpwd: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = newpwd;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/changePassword`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  newLoginUpdate(userID: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = userID;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/newLoginUpdate`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  jiraAuthUpdate(userID: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = userID;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/jiraAuthUpdate`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }


  createAssistantToken(tokenObj: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = tokenObj;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addAssistantToken`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
